import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/makingyousmile.fr/httpdocs/src/components/menu/Menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/makingyousmile.fr/httpdocs/src/contexts/QueryProvider.tsx");
